export const DATE_FORMAT = 'd/MMM/yyyy';
export const DATE_FORMAT_2 = 'yyyy-MM-dd';
export const DATE_FORMAT_SURVEY = 'do MMMM yyyy';
export const TIME_FORMAT = 'h:mm aa';
export const TIME_FORMAT_2 = 'HH:mm';
export const TIME_FORMAT_SURVEY = 'hh mm aa';
export const DATE_FORMAT_CSM = 'd/MMM/yyyy h:mm aa';

export const eventLockedCardDateFormat = 'do MMMM yyyy';
